module.exports = __webpack_public_path__ + "static/img/egg_r_11.ceddb18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/r/egg_r_11.png
// module id = DRhg
// module chunks = 1